import type { MembreEquipe } from '@/types/MembreEquipe'
import { PASTEUR_PORTRAIT_URL } from './media'

// Équipe pastorale du CMP Lubumbashi — valeurs initiales, modifiables depuis /admin. Photos de PRÉVISUALISATION (portraits
// Unsplash, voir data/media.ts) — à remplacer par les vrais portraits.
export const EQUIPE_INITIALE: MembreEquipe[] = [
  {
    id: 'timothee-mbengela',
    nom: 'Timothée MBENGELA',
    fonction: 'Pasteur principal',
    photo: PASTEUR_PORTRAIT_URL,
  },
  {
    id: 'tothy-mbengela',
    nom: 'Tothy MBENGELA',
    fonction: 'Pasteure assistante',
    bio: "Épouse du Pasteur Timothée MBENGELA, mère, motivatrice et visionnaire du ministère ALLIANCE, qui rassemble plusieurs programmes d'édification autour de la Parole de Dieu.",
    photo: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=300&q=65&fm=jpg&fit=crop',
  },
  {
    id: 'zachee-kabongo',
    nom: 'Zachée KABONGO',
    fonction: 'Pasteur assistant',
    bio: 'Marié à Madame Solange KABONGO, père de deux enfants.',
    photo: 'https://images.unsplash.com/photo-1607346256330-dee7af15f7c5?w=300&q=65&fm=jpg&fit=crop',
  },
  {
    id: 'julio-imuanga',
    nom: 'Julio IMUANGA',
    fonction: 'Pasteur associé — administrateur et financier de l\'église',
    bio: 'Marié à Madame Myra MUDERHWA, père de deux enfants.',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&q=65&fm=jpg&fit=crop',
  },
  {
    id: 'henri-fabrice-bukasa',
    nom: 'Henri-Fabrice BUKASA',
    fonction: 'Pasteur associé',
    bio: 'Marié à Madame Jennyfer KALEKA, père de deux enfants.',
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300&q=65&fm=jpg&fit=crop',
  },
  {
    id: 'samy-mwalaba',
    nom: 'Samy MWALABA',
    fonction: 'Pasteur associé — communauté anglophone',
    photo: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=300&q=65&fm=jpg&fit=crop',
  },
  {
    id: 'alliance-nkulu',
    nom: 'Alliance NKULU',
    fonction: 'Pasteur associé',
    photo: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=300&q=65&fm=jpg&fit=crop',
  },
]
